export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "73253c86-4f91-435f-8d40-ea7e5143db3d";
export const MODAL_CLOSE_SEC = 2.5;
export const DEFAULT_ING_AMT = 1;
